import React from 'react'

export const IconArrowLeft = ({ width, height }) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={ width ? width : "32" } height={ height ? height : "32" } viewBox="0 0 32 32" fill="none">
            <path fill="currentColor" d="M28 16a1 1 0 0 1-1 1H7.414l7.294 7.293a.999.999 0 0 1-.325 1.631 1.002 1.002 0 0 1-1.09-.216l-9-9a1 1 0 0 1 0-1.415l9-9a1 1 0 1 1 1.415 1.415L7.414 15H27a1 1 0 0 1 1 1Z"/>
        </svg>
     )
}